/** Shared Swiper transition speeds (ms). Higher = slower, smoother slide animation. */
export const SLIDER_TRANSITION_SPEED = 2000
export const SLIDER_TRANSITION_SPEED_COMPACT = 1170

/** Swiper default when no explicit speed was previously set (300ms). */
export const SLIDER_TRANSITION_SPEED_DEFAULT = 500

/** CSS marquee loop duration (seconds). Higher = slower continuous scroll. */
export const SLIDER_MARQUEE_DURATION = 97
